import { render, staticRenderFns } from "./LeSound.vue?vue&type=template&id=65c9e1bf&scoped=true&"
import script from "./LeSound.vue?vue&type=script&lang=js&"
export * from "./LeSound.vue?vue&type=script&lang=js&"
import style0 from "./LeSound.vue?vue&type=style&index=0&id=65c9e1bf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9e1bf",
  null
  
)

export default component.exports